import proceeding from "./vsa2025_papers";

export default proceeding;